export enum CustomerDisplayType {
    VISOR,
    VIRTUAL
}
